import { Linkedin, Facebook, Briefcase } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl sm:text-5xl font-light text-white text-center mb-16">
          Connect with me
        </h2>

        <div className="max-w-2xl mx-auto">
          {/* Social Connection Cards */}
          <div className="space-y-4 mb-12">
            <a
              href="https://www.linkedin.com/in/nadishan-d/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 border border-gray-800 rounded-sm p-6 bg-white/[0.02] hover:border-gray-700 transition-all duration-300 group"
            >
              <div className="flex-shrink-0">
                <Linkedin className="w-8 h-8 text-gray-400 group-hover:text-white transition-colors duration-300" />
              </div>
              <div>
                <h3 className="text-white text-lg font-medium">LinkedIn</h3>
                <p className="text-gray-400 text-sm font-light mt-1">Connect professionally</p>
              </div>
            </a>

            <a
              href="https://www.facebook.com/share/1bQCJFtF6S/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 border border-gray-800 rounded-sm p-6 bg-white/[0.02] hover:border-gray-700 transition-all duration-300 group"
            >
              <div className="flex-shrink-0">
                <Facebook className="w-8 h-8 text-gray-400 group-hover:text-white transition-colors duration-300" />
              </div>
              <div>
                <h3 className="text-white text-lg font-medium">Facebook</h3>
                <p className="text-gray-400 text-sm font-light mt-1">Follow me</p>
              </div>
            </a>

            <a
              href="https://www.fiverr.com/s/Aym906P"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 border border-gray-800 rounded-sm p-6 bg-white/[0.02] hover:border-gray-700 transition-all duration-300 group"
            >
              <div className="flex-shrink-0">
                <Briefcase className="w-8 h-8 text-gray-400 group-hover:text-white transition-colors duration-300" />
              </div>
              <div>
                <h3 className="text-white text-lg font-medium">Fiverr</h3>
                <p className="text-gray-400 text-sm font-light mt-1">Hire me for projects</p>
              </div>
            </a>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Contact;